import { mediaMax } from '@/app/styles/breakpoints'
import { InvisibleButton } from '@/shared/ui/components/Button'
import { Flex, Typography } from 'antd'
import styled from 'styled-components'

const { Text } = Typography

export const SystemContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('/images/login-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px;

  ${mediaMax.md} {
    background: ${(props) => props.theme.colors.white};
    padding-left: 0;
    padding-right: 0;
    align-items: start;
    padding: 0;
  }
`

export const SystemCard = styled.div`
  width: 100%;
  max-width: 932px;
  background-color: ${(props) => props.theme.colors.grayBackground};
  box-shadow: 8px 16px 64px 0px rgba(5, 117, 186, 0.25);
  border-radius: 6px;
  padding: 32px;
  position: relative;

  ${mediaMax.md} {
    background: ${(props) => props.theme.colors.white};
    max-width: 100%;
    box-shadow: none;
    padding: 0;
  }
`

export const SystemHeader = styled(Flex)`
  ${mediaMax.md} {
    height: 88px;
    border-radius: 0;
    margin-bottom: 0;
    box-shadow: 0px 4px 16px 0px rgba(12, 16, 24, 0.12);
    display: flex;
    align-items: center;
    padding: 0 16px 0 64px;
    flex-direction: row;
  }
`

export const SystemLogo = styled.img`
  height: 21px;
  width: 300px;
  object-fit: contain;
`

export const SystemGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;

  ${mediaMax.md} {
    grid-template-columns: 1fr;
    padding: 0 16px;
    gap: 16px;
  }
`

export const SystemTitle = styled(Text)`
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 16px;
  text-align: center;
  color: #a8a8a8;
  transition: all 0.2s ease;
  ${mediaMax.md} {
    position: relative;
    left: auto;
    bottom: auto;
    width: auto;
  }
`

export const SystemItem = styled(Flex)`
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  height: 200px;
  background-color: #fff;
  position: relative;

  &:hover {
    background: ${(props) => props.theme.colors.subpartners.hover};

    & ${SystemTitle} {
      color: ${(props) => props.theme.colors.primary};
    }
  }

  ${mediaMax.md} {
    background: ${(props) => props.theme.colors.grayBackground};
    height: 88px;
    padding: 0 16px;
  }
`

export const LogoutBtn = styled(InvisibleButton)`
  position: absolute;
  left: 24px;
  top: 26px;
  ${mediaMax.md} {
    left: 16px;
    top: 28px;
  }
`
